import { DatePipe } from '@angular/common';
import { Component, effect, inject } from '@angular/core';
import { Router } from '@angular/router';
import { TranslocoPipe } from '@jsverse/transloco';
import type { OrganizationDto } from '../../shared';
import type { Action } from '@mb/components';
import { DetailsShellComponent, TableStateService } from '@mb/components';
import { createDeleteOrganizationAction } from './organization-admin.actions';
import { OrganizationPersonsComponent } from './organization-persons.component';

@Component({
  // `display: contents` so the drawer's height reaches the details shell:
  // a box of its own here stops `flex-1`/`min-h-0` and the shell's body
  // never becomes scrollable, so the sheet clips the record instead.
  host: { class: 'contents' },
  selector: 'workforce-organization-details',
  standalone: true,
  imports: [
    DetailsShellComponent,
    TranslocoPipe,
    DatePipe,
    OrganizationPersonsComponent,
  ],
  templateUrl: './organization-details.component.html',
})
export class OrganizationDetailsComponent {
  readonly tableStateService = inject(TableStateService<OrganizationDto>);
  readonly #router = inject(Router);
  readonly deleteOrganization = createDeleteOrganizationAction();

  readonly isLoading = this.tableStateService.isLoadingDetails;
  readonly organization = this.tableStateService.selected;

  readonly actions: Action[] = [
    {
      label: 'settings.organizations.actions.edit',
      icon: 'edit',
      function: () => this.edit(),
    },
    {
      label: 'common.actions.delete',
      icon: 'delete',
      linkType: 'danger',
      function: () => this.delete(),
    },
  ];

  constructor() {
    effect(() => {
      const current = this.organization();
      this.tableStateService.setDrawerTitle(current?.name ?? '');
    });
  }

  edit(): void {
    const id = this.tableStateService.selectedId();
    if (id == null) return;
    void this.#router.navigate([
      '/dashboard/settings/organizations',
      String(id),
      'edit',
    ]);
  }

  delete(): void {
    const id = this.tableStateService.selectedId();
    if (id == null) return;
    void this.deleteOrganization(String(id));
  }
}
